import { call, put, select } from 'redux-saga/effects';
import { logger } from '../../../shared/lib';
import { createNotification, snackbarModel } from '../../snackbar';
import { pagesApi } from '../../../shared/api';
import { actions } from '../model/reducer';
import { Page } from '@distribute/shared/types';
import { teamsModel } from '../../teams';

export function* setPagesData(setLoading = true) {
  try {
    const { id: currentTeamId } = yield select(
      teamsModel.selectors.selectCurrentTeamWithError
    );
    if (setLoading) {
      yield put(actions.setPagesStatus('pending'));
    }
    const pages: Page[] = yield call(pagesApi.getPages, currentTeamId);
    yield put(actions.setPages(pages));
    yield put(actions.setPagesStatus('success'));
  } catch (e: unknown) {
    logger.error(e);
    yield put(
      snackbarModel.actions.addNotificationAction(
        createNotification('error', `Failed to show page`)
      )
    );
    yield put(actions.setPagesStatus('error'));
  }
}
